var _excluded = ["className", "srollBarWidth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { useTable } from '../context';
import { useTableImplement, useTableCep } from '../implements/implement';
import { useTableColumnsWidth } from '../implements/size';
export function TableColGroup(props) {
  var className = props.className,
      _props$srollBarWidth = props.srollBarWidth,
      srollBarWidth = _props$srollBarWidth === void 0 ? 0 : _props$srollBarWidth,
      attrs = _objectWithoutProperties(props, _excluded);

  var cep = useTableCep();
  var implement = useTableImplement();
  var context = useTable();
  var columnsWidth = useTableColumnsWidth();
  return useMemo(function () {
    var elem = cep.elem;
    var isTable = implement.isTable,
        ColGroup = implement.ColGroup,
        Col = implement.Col;
    var leafColumns = context.leafColumns;
    var widthMap = columnsWidth.widthMap;

    if (!isTable) {
      return null;
    }

    var elemCol = elem('Col');
    return React.createElement(ColGroup, _objectSpread({
      className: elem('ColGroup')
    }, attrs), leafColumns.map(function (col, index) {
      var path = col.path;
      var width = widthMap.get(col);
      return React.createElement(Col, {
        key: "col.".concat(path.join('.')),
        className: elemCol,
        style: {
          width: "".concat(width + (leafColumns.length - 1 === index ? srollBarWidth : 0), "px")
        }
      });
    }));
  }, [cep, implement, context, columnsWidth]);
}